import React, { useState,useEffect } from "react";
import {
  Col,
  Container,
  Row,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
  Modal,
  ModalBody,
  //Form,
  FormGroup,
  Label,
  Spinner,
  /* Alert, */
  Button
} from "reactstrap";
import axios from 'axios';
import { AppConfiguration } from "read-appsettings-json";
import moment from 'moment';
//import useForm from "./useForm";
import InputGroup from 'react-bootstrap/InputGroup';
import Resizer from "react-image-file-resizer";
import {  Card,   CardBody } from "reactstrap";
import lightLogo from "../../assets/images/logo-light.png";
import darkLogo from "../../assets/images/logo-dark.png";
import signUpImage from "../../assets/images/auth/sign-up.png";
//import useForm from "../../wcomponents/SignUp/useForm";
import Icon from "../../wcomponents/Icon/Icon";
import "../../wcomponents/w.css"
import NavBar from "../../Layout/CommonLayout/NavBar"//"../CommonLayout/NavBar";
import ScrolltoTop from "../../components/ScrolltoTop";
import TopBar from "../../Layout/CommonLayout/TopBar";
import { setSelection } from "@testing-library/user-event/dist/cjs/event/selection/setSelection.js";
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import { FormControl } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Link, Navigate } from "react-router-dom";
// import Alert from 'react-bootstrap/Alert';
import { useForm } from "react-hook-form";
import { render } from "react-dom";
//import TextareaAutosize from "react-textarea-autosize";

import {Alert} from "reactstrap";
import AWS from "aws-sdk";


const CompanyDocuments = ({submitForm }) => {
    const [userdata, setUserdata] = useState(JSON.parse(sessionStorage.getItem("userdata")));
    const navigate = useNavigate();
    const [pagePath, setPagePath] = useState(true)
    const [show, setShow] = useState(false);
    const [dissableBtn, setDissableBtn] = useState(true);
    const [isChecked, setIsChecked] = useState(false);
    const { errors, register, handleSubmit, control } = useForm();

    const [secCertificate,setSecCertififacte] =useState({});
    const [secCertBase64,setsecCertBase64] =useState("");

    const [companyArticles, setcompanyArticles] = useState({})
    const [companyArticlesBase64, setcompanyArticlesBase64] = useState("")

    const [BirCertificate, setBirCertificate] = useState({})
    const [BirCertificateBase64, setBirCertificateBase64] = useState("")

    const [businessPermit, setbusinessPermit] = useState({})
    const [businessPermitBase64, setbusinessPermitBase64] = useState("")

    const [companyOwnerId, setcompanyOwnerId] = useState({})
    const [companyOwnerIdBase64, setcompanyOwnerIdBase64] = useState("")

    const [doleRegistered, setdoleRegistered] = useState({})
    const [doleRegisteredBase64, setdoleRegisteredBase64] = useState("")

    const [peza,setPeza] = useState({})
    const [pezaBase64, setpezaBase64] = useState("")




    const [headerId, setheaderId] = useState("")
    const [arr1, setarr] = useState([])
    const [isshow, setisshow] = useState(false)
    const [color, setcolor] = useState("")
    const [message, setmessage] = useState("")
    const [fade, setfade] = useState("")
    const [alerttype, setalerttype] = useState("")
    const [disableSave, setdisableSave] = useState(false);
    const [selectetdFile, setSelectedFile] = useState([]);
    const [fileBase64String, setFileBase64String] = useState("");

    useEffect(
        () => {
            console.log("CompanyDocuments")
          getFormattedDateTime()
        },
        []
    );
    const handleCheckBox =(event)=>{
        console.log(event.target.checked)
        if(event.target.checked === true){
            setIsChecked(true)
            setDissableBtn(false)
            //setAgree("YES")
            //console.log("yes")
          }else{
            setIsChecked(false)
            setDissableBtn(true)
            //setAgree("NO")
            //console.log("no")
          }
    };
    
    // const onFormSubmit=()=>{
    //     // sessionStorage.setItem("userdata", JSON.stringify(userdata))
    //     // window.sessionStorage.setItem('results', JSON.stringify({"menuId" : "002"}));

    //     // let secOBJ = {
    //     //     "name" : secCertificate.name,
    //     //     "size" : secCertificate.size,
    //     //     "type" : secCertificate.type,
    //     //     "path" : "opt/noser",
    //     //     "base64" : secCertBase64,
    //     //     "isModified" : "0",
    //     //     "modifiedDate" : ""
    //     // };
    //     // let companyArticlesOBJ = {
    //     //     "name" : companyArticles.name,
    //     //     "size" : companyArticles.size,
    //     //     "type" : companyArticles.type,
    //     //     "path" : "opt/noser",
    //     //     "base64" : companyArticlesBase64,
    //     //     "isModified" : "0",
    //     //     "modifiedDate" : ""
    //     // };
    //     // let birCertificatelesOBJ = {
    //     //     "name" : BirCertificate.name,
    //     //     "size" : BirCertificate.size,
    //     //     "type" : BirCertificate.type,
    //     //     "path" : "opt/noser",
    //     //     "base64" : BirCertificateBase64,
    //     //     "isModified" : "0",
    //     //     "modifiedDate" : ""
    //     // };
    //     // let businessPermitOBJ = {
    //     //     "name" : businessPermit.name,
    //     //     "size" : businessPermit.size,
    //     //     "type" : businessPermit.type,
    //     //     "path" : "opt/noser",
    //     //     "base64" : businessPermitBase64,
    //     //     "isModified" : "0",
    //     //     "modifiedDate" : ""
    //     // };
    //     // let companyOwnerIdOBJ = {
    //     //     "name" : companyOwnerId.name,
    //     //     "size" : companyOwnerId.size,
    //     //     "type" : companyOwnerId.type,
    //     //     "path" : "opt/noser",
    //     //     "base64" : setcompanyOwnerIdBase64,
    //     //     "isModified" : "0",
    //     //     "modifiedDate" : ""
    //     // };
    //     // let doleRegisteredOBJ = {
    //     //     "name" : doleRegistered.name,
    //     //     "size" : doleRegistered.size,
    //     //     "type" : doleRegistered.type,
    //     //     "path" : "opt/noser",
    //     //     "base64" : doleRegisteredBase64,
    //     //     "isModified" : "0",
    //     //     "modifiedDate" : ""
    //     // };
    //     // let pezaOBJ = {
    //     //     "name" : peza.name,
    //     //     "size" : peza.size,
    //     //     "type" : peza.type,
    //     //     "path" : "opt/noser",
    //     //     "base64" : pezaBase64,
    //     //     "isModified" : "0",
    //     //     "modifiedDate" : ""
    //     // };
        

    //     // let obj = {
    //     //     "secCertificate" : secOBJ,
    //     //     "companyArticles" : companyArticlesOBJ,
    //     //     "birCertificate" : birCertificatelesOBJ,
    //     //     "businessPermit" : businessPermitOBJ,
    //     //     "companyOwnerId"    :companyOwnerIdOBJ,
    //     //     "doleRegistered"    : doleRegisteredOBJ,
    //     //     "peza"      : pezaOBJ,
    //     //     "userId"    : userdata[0].userid
    //     // };
    //     // console.log(obj)

    //     // const params = {
    //     //     // "dbname"      :  AppConfiguration.Setting().noserJobSpaceDB_Prod,
    //     //     "_collection" : "CompanyDocuments",
    //     //     "doc_data" : obj
    //     // }
    //     // console.log("params")
    //     // console.log(params)
    //     // axios
    //     // .post(AppConfiguration.Setting().jobspaceapi + "action/add", params )
    //     // .then(res => {
           
    //     // console.log("res")
    //     // console.log(res.status)
    //     // console.log(res.data)
    //     // if(res.status === 200){
    //     //     handleGetCompanyChecklist()
    //     // }
        
    //     // })
    //     // .catch(error=>{
    //     //     console.log("error: " + error)
    //     //     console.log("ewwow")
    //     // }) 
    //     // //navigate("/ContinueR");
    //     const now = new Date();
    //     const year = now.getFullYear();
    //     const month = String(now.getMonth() + 1).padStart(2, '0');
    //     const day = String(now.getDate()).padStart(2, '0');
    //     const hours = String(now.getHours()).padStart(2, '0');
    //     const minutes = String(now.getMinutes()).padStart(2, '0');
    //     const seconds = String(now.getSeconds()).padStart(2, '0');
    //     //const miliseconds = String(now.getMilliseconds()).padStart(2, '0');
    //     let globalNewId = `${year}${month}${day}${hours}${minutes}${seconds}`
    //     console.log(globalNewId)
    //     uploadFile1(globalNewId)
    //     uploadFile2(globalNewId)
    //     handleGetCompanyChecklist(globalNewId)



    // };
    const [id, setId] = useState("");
    const generateId = () => {
        let uuid = ""
        try {
            
        // Check if crypto.randomUUID exists
        if (window.crypto && crypto.randomUUID) {
            uuid = crypto.randomUUID()
            setId(crypto.randomUUID());
        } else {
            // Fallback for older browsers
            setId("xxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
            const r = (Math.random() * 16) | 0;
            const v = c === "x" ? r : (r & 0x3) | 0x8;
            uuid = v.toString(16);
            return v.toString(16);
            }));
        }
        } catch (err) {
        console.error("Error generating UUID:", err);
        setId("Error generating UUID");
        }

        return uuid
    };

    const onFormSubmit=()=>{
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        //const miliseconds = String(now.getMilliseconds()).padStart(2, '0');
        let globalNewId = `${year}${month}${day}${hours}${minutes}${seconds}`
        let arr = [
            {"id" : "0","name" : secCertificate.name, "newId" : ""},
            {"id" : "1","name" : companyArticles.name, "newId" : ""},
            {"id" : "2","name" : BirCertificate.name, "newId" : ""},
            {"id" : "3","name" : businessPermit.name, "newId" : ""},
            {"id" : "4","name" : companyOwnerId.name, "newId" : ""},
            {"id" : "5","name" : doleRegistered.name, "newId" : ""},
            {"id" : "6","name" : peza.name, "newId" : ""},
        ]
        //const uuid = crypto.randomUUID();
        console.log(arr)
        let sec     // 0
        let caoi    // 1
        let bir     // 2
        let bp      // 3
        let coi     // 4
        let dole     // 5
        let pezatmp     // 6

        //sec
        const sefFile = secCertificate.name;
        const fileExtensionsec = sefFile.split('.').pop();
        const baseFilenamesec= sefFile.substring(0, sefFile.lastIndexOf('.'));
        const newFilenamesec = `${baseFilenamesec}-${generateId()}.${fileExtensionsec}`;

        //Caoi
        const caoiFile = companyArticles.name;
        const fileExtensioncao = caoiFile.split('.').pop();
        const baseFilenamecao= caoiFile.substring(0, caoiFile.lastIndexOf('.'));
        const newFilenamecao = `${baseFilenamecao}-${generateId()}.${fileExtensioncao}`;

        //BIR
        const birFile = BirCertificate.name;
        const fileExtensionbir = birFile.split('.').pop();
        const baseFilenamebir= birFile.substring(0, birFile.lastIndexOf('.'));
        const newFilenamebir = `${baseFilenamebir}-${generateId()}.${fileExtensionbir}`;

        //business permit
        const bpFile = businessPermit.name;
        const fileExtensionbp = bpFile.split('.').pop();
        const baseFilenamebp= bpFile.substring(0, bpFile.lastIndexOf('.'));
        const newFilenamebp = `${baseFilenamebp}-${generateId()}.${fileExtensionbp}`;

        //company owner Id
        const coiFile = companyOwnerId.name;
        const fileExtensioncoi = coiFile.split('.').pop();
        const baseFilenamecoi= coiFile.substring(0, coiFile.lastIndexOf('.'));
        const newFilenamecoi = `${baseFilenamecoi}-${generateId()}.${fileExtensioncoi}`;

        //dole
        const doleFile = doleRegistered.name;
        const fileExtensiondole = doleFile.split('.').pop();
        const baseFilenamedole= doleFile.substring(0, doleFile.lastIndexOf('.'));
        const newFilenamedole = `${baseFilenamedole}-${generateId()}.${fileExtensiondole}`;

        // peza
        const pezaFile = peza.name;
        const fileExtensionpeza = pezaFile.split('.').pop();
        const baseFilenamepeza= pezaFile.substring(0, pezaFile.lastIndexOf('.'));
        const newFilenamepeza = `${baseFilenamepeza}-${generateId()}.${fileExtensionpeza}`;


        arr.forEach(element => {
            if(element.id === "0"){
                let a = []
                a.push(element)
                a.forEach(element2 => {
                    element2.newId = newFilenamesec
                    sec = element2
                });
            };
            if(element.id === "1"){
                let a = []
                a.push(element)
                a.forEach(element2 => {
                    element2.newId = newFilenamecao
                    caoi = element2
                });
            };
            if(element.id === "2"){
                let a = []
                a.push(element)
                a.forEach(element2 => {
                    element2.newId = newFilenamebir
                    bir = element2
                });
            };
            if(element.id === "3"){
                let a = []
                a.push(element)
                a.forEach(element2 => {
                    element2.newId = newFilenamebp
                    bp = element2
                });
            };
            if(element.id === "4"){
                let a = []
                a.push(element)
                a.forEach(element2 => {
                    element2.newId = newFilenamecoi
                    coi = element2
                });
            };
            if(element.id === "5"){
                let a = []
                a.push(element)
                a.forEach(element2 => {
                    element2.newId = newFilenamedole
                    dole = element2
                });
            };
            if(element.id === "6"){
                let a = []
                a.push(element)
                a.forEach(element2 => {
                    element2.newId = newFilenamepeza
                    pezatmp = element2
                });
            };
            
        });
        console.log("arr")
        console.log(arr)
        
        uploadFile1(sec)
        uploadFile2(caoi)
        uploadFile3(bir)
        uploadFile4(bp)
        uploadFile5(coi)
        uploadFile6(dole)
        uploadFile7(pezatmp)
        handleGetCompanyChecklist(arr)
    };

    const uploadFile1 = (data) => {
        console.log(data)
        const { uploadResume, s3NewId } = secCertificate;
        
    
        if (!secCertificate || !secCertificate.name) {
            alert("No resume file selected. Please select a valid resume file.");
            return;
        }
    
        const filename = secCertificate.name;
        const validFilenamePattern = /^[a-zA-Z0-9._-]+$/;
        if (!validFilenamePattern.test(filename)) {
            alert("Invalid filename. Please use alphanumeric characters, dots, underscores, or hyphens only and reupload your file.");
            return;
        }
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        const miliseconds = String(now.getMilliseconds()).padStart(2, '0');
        //let globalNewId = `${year}${month}${day}${hours}${minutes}${seconds}${miliseconds}`
        // now.setSeconds(now.getSeconds());
        const newId = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(now.getSeconds()).padStart(2, '0')}`;
        const fileExtension = filename.split('.').pop();
        const baseFilename = filename.substring(0, filename.lastIndexOf('.'));
        
        // const newFilename = `${baseFilename}-${newId}.${fileExtension}`;
        //const newFilename = `${baseFilename}-${data.newId}.${fileExtension}`;
        const newFilename = `${data.newId}`;

        const S3_BUCKET = 'job-space-bucket-noser-cdr';
        const REGION = 'us-east-1';
        const ACCESS_KEY = AppConfiguration.Setting().accessKeyId;
        const SECRET_KEY = AppConfiguration.Setting().secretAccessKey;
    
        AWS.config.update({
            accessKeyId: ACCESS_KEY,
            secretAccessKey: SECRET_KEY,
            region: REGION,
        });
    
        const s3 = new AWS.S3();
        const params = {
            Bucket: S3_BUCKET,
            Key: newFilename,
            Body: secCertificate,
            ACL: 'bucket-owner-full-control',
        };
        console.log("params sec")
        console.log(params)
    
        s3.upload(params, (err, data) => {
            if (err) {
                console.log("Error uploading file:", err);
                alert("Error uploading file.");
            } else {
                console.log("Successfully uploaded file:", data);
                
            }
        });
        
      
    };
    const uploadFile2 = (data,) => {
        const { uploadResume, s3NewId } = companyArticles;
     
    
        if (!companyArticles || !companyArticles.name) {
            alert("No resume file selected. Please select a valid resume file.");
            return;
        }
    
        const filename = companyArticles.name;
        const validFilenamePattern = /^[a-zA-Z0-9._-]+$/;
        if (!validFilenamePattern.test(filename)) {
            alert("Invalid filename. Please use alphanumeric characters, dots, underscores, or hyphens only and reupload your file.");
            return;
        }
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        const miliseconds = String(now.getMilliseconds()).padStart(2, '0');
        const newId = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(now.getSeconds()).padStart(2, '0')}`;
        const fileExtension = filename.split('.').pop();
        const baseFilename = filename.substring(0, filename.lastIndexOf('.'));
        const newFilename = `${data.newId}`;

        const S3_BUCKET = 'job-space-bucket-noser-cdr';
        const REGION = 'us-east-1';
        const ACCESS_KEY = AppConfiguration.Setting().accessKeyId;
        const SECRET_KEY = AppConfiguration.Setting().secretAccessKey;
    
        AWS.config.update({
            accessKeyId: ACCESS_KEY,
            secretAccessKey: SECRET_KEY,
            region: REGION,
        });
    
        const s3 = new AWS.S3();
        const params = {
            Bucket: S3_BUCKET,
            Key: newFilename,
            Body: companyArticles,
            ACL: 'bucket-owner-full-control',
        };
        console.log("params caoi")
        console.log(params)
    
        s3.upload(params, (err, data) => {
            if (err) {
                console.log("Error uploading file:", err);
                alert("Error uploading file.");
            } else {
                console.log("Successfully uploaded file:", data);
                
            }
        });
    };
    const uploadFile3 = (data,) => {
        const { uploadResume, s3NewId } = BirCertificate;
    
        if (!BirCertificate || !BirCertificate.name) {
            alert("No resume file selected. Please select a valid resume file.");
            return;
        };
    
        const filename = BirCertificate.name;
        const validFilenamePattern = /^[a-zA-Z0-9._-]+$/;
        if (!validFilenamePattern.test(filename)) {
            alert("Invalid filename. Please use alphanumeric characters, dots, underscores, or hyphens only and reupload your file.");
            return;
        };
        const newFilename = `${data.newId}`;
        const S3_BUCKET = 'job-space-bucket-noser-cdr';
        const REGION = 'us-east-1';
        const ACCESS_KEY = AppConfiguration.Setting().accessKeyId;
        const SECRET_KEY = AppConfiguration.Setting().secretAccessKey;
    
        AWS.config.update({
            accessKeyId: ACCESS_KEY,
            secretAccessKey: SECRET_KEY,
            region: REGION,
        });
    
        const s3 = new AWS.S3();
        const params = {
            Bucket: S3_BUCKET,
            Key: newFilename,
            Body: BirCertificate,
            ACL: 'bucket-owner-full-control',
        };
        console.log("params BirCertificate")
        console.log(params)
    
        s3.upload(params, (err, data) => {
            if (err) {
                console.log("Error uploading file:", err);
                alert("Error uploading file.");
            } else {
                console.log("Successfully uploaded file:", data);
                
            }
        });
    };
    const uploadFile4 = (data,) => {
        const { uploadResume, s3NewId } = businessPermit;
    
        if (!businessPermit || !businessPermit.name) {
            alert("No resume file selected. Please select a valid resume file.");
            return;
        };
    
        const filename = businessPermit.name;
        const validFilenamePattern = /^[a-zA-Z0-9._-]+$/;
        if (!validFilenamePattern.test(filename)) {
            alert("Invalid filename. Please use alphanumeric characters, dots, underscores, or hyphens only and reupload your file.");
            return;
        };
        const newFilename = `${data.newId}`;
        const S3_BUCKET = 'job-space-bucket-noser-cdr';
        const REGION = 'us-east-1';
        const ACCESS_KEY = AppConfiguration.Setting().accessKeyId;
        const SECRET_KEY = AppConfiguration.Setting().secretAccessKey;
    
        AWS.config.update({
            accessKeyId: ACCESS_KEY,
            secretAccessKey: SECRET_KEY,
            region: REGION,
        });
    
        const s3 = new AWS.S3();
        const params = {
            Bucket: S3_BUCKET,
            Key: newFilename,
            Body: businessPermit,
            ACL: 'bucket-owner-full-control',
        };
        console.log("params businessPermit")
        console.log(params)
    
        s3.upload(params, (err, data) => {
            if (err) {
                console.log("Error uploading file:", err);
                alert("Error uploading file.");
            } else {
                console.log("Successfully uploaded file:", data);
                
            }
        });
    };
    const uploadFile5 = (data,) => {
        const { uploadResume, s3NewId } = companyOwnerId;
    
        if (!companyOwnerId || !companyOwnerId.name) {
            alert("No resume file selected. Please select a valid resume file.");
            return;
        };
    
        const filename = companyOwnerId.name;
        const validFilenamePattern = /^[a-zA-Z0-9._-]+$/;
        if (!validFilenamePattern.test(filename)) {
            alert("Invalid filename. Please use alphanumeric characters, dots, underscores, or hyphens only and reupload your file.");
            return;
        };
        const newFilename = `${data.newId}`;
        const S3_BUCKET = 'job-space-bucket-noser-cdr';
        const REGION = 'us-east-1';
        const ACCESS_KEY = AppConfiguration.Setting().accessKeyId;
        const SECRET_KEY = AppConfiguration.Setting().secretAccessKey;
    
        AWS.config.update({
            accessKeyId: ACCESS_KEY,
            secretAccessKey: SECRET_KEY,
            region: REGION,
        });
    
        const s3 = new AWS.S3();
        const params = {
            Bucket: S3_BUCKET,
            Key: newFilename,
            Body: companyOwnerId,
            ACL: 'bucket-owner-full-control',
        };
        console.log("params companyOwnerId")
        console.log(params)
    
        s3.upload(params, (err, data) => {
            if (err) {
                console.log("Error uploading file:", err);
                alert("Error uploading file.");
            } else {
                console.log("Successfully uploaded file:", data);
                
            }
        });
    };
    const uploadFile6 = (data,) => {
        const { uploadResume, s3NewId } = doleRegistered;
    
        if (!doleRegistered || !doleRegistered.name) {
            alert("No resume file selected. Please select a valid resume file.");
            return;
        };
    
        const filename = doleRegistered.name;
        const validFilenamePattern = /^[a-zA-Z0-9._-]+$/;
        if (!validFilenamePattern.test(filename)) {
            alert("Invalid filename. Please use alphanumeric characters, dots, underscores, or hyphens only and reupload your file.");
            return;
        };
        const newFilename = `${data.newId}`;
        const S3_BUCKET = 'job-space-bucket-noser-cdr';
        const REGION = 'us-east-1';
        const ACCESS_KEY = AppConfiguration.Setting().accessKeyId;
        const SECRET_KEY = AppConfiguration.Setting().secretAccessKey;
    
        AWS.config.update({
            accessKeyId: ACCESS_KEY,
            secretAccessKey: SECRET_KEY,
            region: REGION,
        });
    
        const s3 = new AWS.S3();
        const params = {
            Bucket: S3_BUCKET,
            Key: newFilename,
            Body: doleRegistered,
            ACL: 'bucket-owner-full-control',
        };
        console.log("params doleRegistered")
        console.log(params)
    
        s3.upload(params, (err, data) => {
            if (err) {
                console.log("Error uploading file:", err);
                alert("Error uploading file.");
            } else {
                console.log("Successfully uploaded file:", data);
                
            }
        });
    };
    const uploadFile7 = (data,) => {
        const { uploadResume, s3NewId } = peza;
    
        if (!doleRegistered || !doleRegistered.name) {
            alert("No resume file selected. Please select a valid resume file.");
            return;
        };
    
        const filename = doleRegistered.name;
        const validFilenamePattern = /^[a-zA-Z0-9._-]+$/;
        if (!validFilenamePattern.test(filename)) {
            alert("Invalid filename. Please use alphanumeric characters, dots, underscores, or hyphens only and reupload your file.");
            return;
        };
        const newFilename = `${data.newId}`;
        const S3_BUCKET = 'job-space-bucket-noser-cdr';
        const REGION = 'us-east-1';
        const ACCESS_KEY = AppConfiguration.Setting().accessKeyId;
        const SECRET_KEY = AppConfiguration.Setting().secretAccessKey;
    
        AWS.config.update({
            accessKeyId: ACCESS_KEY,
            secretAccessKey: SECRET_KEY,
            region: REGION,
        });
    
        const s3 = new AWS.S3();
        const params = {
            Bucket: S3_BUCKET,
            Key: newFilename,
            Body: doleRegistered,
            ACL: 'bucket-owner-full-control',
        };
        console.log("params doleRegistered")
        console.log(params)
    
        s3.upload(params, (err, data) => {
            if (err) {
                console.log("Error uploading file:", err);
                alert("Error uploading file.");
            } else {
                console.log("Successfully uploaded file:", data);
                
            }
        });
    };

    const handleGetCompanyChecklist = async(data) => {
        console.log("handleGetCompanyChecklist")
        let filter_data = {
          "isDeleted" : "0", 
          "userId" : userdata[0].userid,
          //"isDeleted" : "0",
         /*  "firstName" : firstName,
          "lastName"  : lastName, */
        }
        
        const Params = {
          "_collection" : "CompanyRegisteredCheckList",
          "filter_data" : filter_data
        }
        console.log("Params")
        console.log(Params)
        console.log("s")
         axios
         .post(AppConfiguration.Setting().jobspaceapi + "action/get", Params)
        .then(res => {

            console.log("res.data")
            console.log(res)
    
            let dataTmp = []
            let a
            let dataaa = res.data
            console.log("data")
            console.log(dataaa)
            let newstr2=""
            dataaa.CompanyRegisteredCheckList.map(function(itm,i){
                let strJson = "{" + itm.substring(46, itm.length)
                let strJson2 = itm.substring(18, itm.length)
                newstr2 = strJson2.split("')")[0]
                let json = JSON.parse(strJson.replace(/'/g,'"'));
                json.headerId = newstr2
                //console.log(json.headerId)
                //setheaderId(json.headerId)
                dataTmp.push(json)
                a = json
            })    
            // setheaderId(dataTmp[0].h)
            //updateCompanyRegisteredCheckList()
            let d = new Date();
            let createddate = moment(d).format('MM/DD/YYYY');
            let w = d.toLocaleTimeString()
            
            dataTmp.forEach(element => {
                element.businessPermit ="1"
                element.data = data
                element.isModifiedDate = w
            });
            console.log("dataTmp")
            console.log(dataTmp)
            setheaderId(dataTmp[0].headerId)
            //let b =  
            setarr(dataTmp)
            if(res.status === 200){
                updateCompanyRegisteredCheckList(a,dataTmp)
            }
        })
        .catch(error =>{
            alert("error: " + error)
        })
    };

    const updateCompanyRegisteredCheckList=(a,dataTmp)=>{
        console.log(headerId)
        console.log(a)
        console.log(arr1)
        //console.log(dataTmp[0])

        let d = new Date();
        let createddate = moment(d).format('MM/DD/YYYY');
        let w = d.toLocaleTimeString()
        //User for Client ID
        let today = new Date()
        let clientId = moment(today).format('MMYYYYhhmmss');
        let obj = {
          "userId" : userdata[0].userid,
          "basicInfoCompany" :a.basicInfoCompany,
          "businessPermit" :"1",
          "isDeleted" : "0",
          "createdDate"             :a.createdDate,
          "timestamp"               : a.timestamp,
          "isDraft"                 : "0",
          "isModifiedDate"          : w,
          
        }
        //let 

        const updateParams = {

            "_collection" : "CompanyRegisteredCheckList",
            "doc_data"    : dataTmp[0],
            "_id"         :dataTmp[0].headerId,
  
        }

      console.log(" toUpdate")
      console.log(updateParams)
  
      axios
      .post(AppConfiguration.Setting().jobspaceapi + "action/update_one", updateParams)
      .then(res => {
        let data = res.data
        console.log(data)
        if(res.status === 200){
            handleGetCompanyChecklist2()
        }
       
       
        }).catch(error =>{
            alert("error: " + error)
        })
    };

    const handleGetCompanyChecklist2 = async() => {
        console.log("handleGetCompanyChecklist")
        let filter_data = {
          "isDeleted" : "0", 
          "userId" : userdata[0].userid
          //"isDeleted" : "0",
         /*  "firstName" : firstName,
          "lastName"  : lastName, */
        }
        
        const Params = {
          "_collection" : "CompanyRegisteredCheckList",
          "filter_data" : filter_data
        }
        console.log("Params")
        console.log(Params)
        console.log("s")
         axios
         .post(AppConfiguration.Setting().jobspaceapi + "action/get", Params)
        .then(res => {

            console.log("res.data")
            console.log(res)
    
            let dataTmp = []
            let a
            let dataaa = res.data
            console.log("data")
            console.log(dataaa)
            let newstr2=""
            dataaa.CompanyRegisteredCheckList.map(function(itm,i){
              let strJson = "{" + itm.substring(46, itm.length)
              let strJson2 = itm.substring(18, itm.length)
              newstr2 = strJson2.split("')")[0]
              let json = JSON.parse(strJson.replace(/'/g,'"'));
              json.headerId = newstr2
              //console.log(json.headerId)
              //setheaderId(json.headerId)
              dataTmp.push(json)
              //a = json
            })    
           // setheaderId(dataTmp[0].h)
            //updateCompanyRegisteredCheckList()
            console.log("dataTmp")
            console.log(dataTmp)
            /* dataTmp.forEach(element => {
                element.basicInfoCompany ="1"
            });*/
            if(res.status === 200){
                copyToClipboard()
              
            } 
           
            //sessionStorage.setItem("CompanyProfile", JSON.stringify(dataTmp))
        })
        .catch(error =>{
            alert("error: " + error)
        })
    };
    
    const copyToClipboard = (e) => {
        const timeoutId = setTimeout(() => {
            console.log("timeoutId")
            console.log(timeoutId)
            setdisableSave(true)
            setalerttype("Success!")
            setisshow(true)
            setcolor("success")
            setmessage("Succesfully Submitted")
            setfade(true)
        }, 3000);
        const timeoutIds = setTimeout(() => {
            console.log("timeoutId")
            console.log(timeoutIds)
            navigate("/CompanyDocuments")
            navigate("/DocumentsSuccess")
        }, 5000);
    };
    const convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);

            fileReader.onload = () => {
            resolve(fileReader.result);
            };

            fileReader.onerror = (error) => {
            reject(error);
            };
        });
    };
    
    const encodeFileBase64 = (file) => {
        var reader = new FileReader();
        if (file) {
            reader.readAsDataURL(file);
            reader.onload = () => {
            var Base64 = reader.result;
            console.log(Base64);
            setFileBase64String(Base64);
            };
            reader.onerror = (error) => {
            console.log("error: ", error);
            };
        }
    };
    const decodeFileBase64 = (base64String) => {
        // From Bytestream to Percent-encoding to Original string
        return decodeURIComponent(
        atob(base64String)
            .split("")
            .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16).slice(-2));
            })
            .join("")
        );
    };
    const decodeBase64 = decodeFileBase64(
        fileBase64String.substring(fileBase64String.indexOf(",") + 1)
    );

    const getFormattedDateTime = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
    
        return `${year}${month}${day}${hours}${minutes}${seconds}`;
    };

    const fileUploadChangedHandlersecFile=(event)=> {
        const selectedFile = event.target.files[0];
        console.log(selectedFile)
        if(selectedFile === undefined){
            setSecCertififacte([])
            return
        }
        setSecCertififacte(selectedFile)
    };
    const fileUploadChangedHandlersArticleFile=(event)=> {
        const selectedFile = event.target.files[0];
        console.log(selectedFile)
        if(selectedFile === undefined){
            setcompanyArticles([])
            return
        }
        setcompanyArticles(selectedFile)
    };
    const fileUploadChangedHandlerBIRFile=(event)=> {
        const selectedFile = event.target.files[0];
        console.log(selectedFile)
        if(selectedFile === undefined){
            setBirCertificate([])
            return
        }
        setBirCertificate(selectedFile)
    };

    const businessPermitChange = async(event)=>{
        const selectedFile = event.target.files[0];
        console.log(selectedFile)
        if(selectedFile === undefined){
            setbusinessPermit([])
            return
        }
        setbusinessPermit(selectedFile)   
    };
    const companyOwnerIdChange = async(event)=>{
       const selectedFile = event.target.files[0];
        console.log(selectedFile)
        if(selectedFile === undefined){
            setcompanyOwnerId([])
            return
        }
        setcompanyOwnerId(selectedFile)   
    };
    const DOLEregisteredChange = async(event)=>{
         const selectedFile = event.target.files[0];
        console.log(selectedFile)
        if(selectedFile === undefined){
            setdoleRegistered([])
            return
        }
        setdoleRegistered(selectedFile)
    };
    const PEZAchange = async(event)=>{
         const selectedFile = event.target.files[0];
        console.log(selectedFile)
        if(selectedFile === undefined){
            setPeza([])
            return
        }
        setPeza(selectedFile)
    };

    

    return (
        <React.Fragment  >
         {/*  <TopBar /> */}
           <NavBar />
          <div > 
            
                  <Container fluid='true' >
                   
                   <Row className="mt-3"></Row>
                   <Row className="mt-3"></Row>
                   
                    <Row className="justify-content-center">
                    
                    <Col sm={5} >
                        <div className="CRcard-two">
                           <Form onSubmit={handleSubmit(onFormSubmit)}>
                                <Alert isOpen={isshow} color={color} fade={fade} className={isshow ? 'display-block' : 'display-none'}>
                                    <div className={color}></div> 
                                    {message}
                                </Alert>
                                <Row>
                                    <Form.Text className=" ml5percent mt-4 ">To ensure the legitimacy of your company and the job hiring you posted,</Form.Text>
                                </Row>
                                <Row>
                                    <Form.Text className="ml5percent  ">below list of company documents are required</Form.Text>
                                </Row>
                                <Row>
                                <h4 className=" ccpLabel mt-4 mb-2">Upload Company Documents </h4>
                                </Row>
                                <Row className="mt-3">
                                    <Col>
                                        <Form.Label className="ml5percent mt-2">SEC Certificate of Registration</Form.Label>
                                    </Col>
                                    <Col sm={5}>
                                        <Form.Control
                                            style={{width: "280px"}}
                                            className="" type="file" size="sm"
                                            //name="secCertificate"
                                            //value={secCertificate} 
                                            onChange={fileUploadChangedHandlersecFile}
                                            required
                                        />
                                    </Col>
                                    <Col sm={1}></Col>
                                </Row>
                               
                                <Row className="mt-3">
                                    <Col sm={6}>
                                        <Form.Label className="ml5percent mt-2">Company Articles of Incorporation</Form.Label>
                                    </Col>
                                    <Col sm={5}>
                                        <Form.Control
                                            required
                                            style={{width: "280px"}}   
                                            className="asd" 
                                            type="file" 
                                            size="sm" 
                                            onChange={fileUploadChangedHandlersArticleFile}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-3">
                                    <Col sm={6}>
                                        <Form.Label className="ml5percent mt-2">BIR Certificate of Registration </Form.Label>
                                    </Col>
                                    <Col sm={5}>
                                        <Form.Control  
                                            required  
                                            style={{width: "280px"}}   
                                            className="asd" 
                                            type="file" 
                                            size="sm" 
                                            onChange={fileUploadChangedHandlerBIRFile}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-3">
                                    <Col sm={6}>
                                        <Form.Label className="ml5percent mt-2">Business Permit</Form.Label>
                                    </Col>
                                    <Col sm={5}>
                                            <Form.Control  
                                            required  
                                            style={{width: "280px"}}   
                                            className="asd" 
                                            type="file" 
                                            size="sm" 
                                            onChange={businessPermitChange}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-3">
                                    <Col sm={6}>
                                        <Form.Label className="ml5percent mt-2">Company Owner/President ID </Form.Label>
                                    </Col>
                                    <Col sm={5}>
                                        <Form.Control   
                                            style={{width: "280px"}}   
                                            className="asd" 
                                            type="file" 
                                            size="sm" 
                                            onChange={companyOwnerIdChange}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-3">
                                    <Col sm={6}>
                                        <Form.Label className="ml5percent mt-2">DOLE Registration</Form.Label>
                                    </Col>
                                    <Col sm={5}>
                                        <Form.Control 
                                            style={{width: "280px"}}  
                                            className="asd" 
                                            type="file" 
                                            size="sm" 
                                            onChange={DOLEregisteredChange}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-3">
                                    <Col sm={6}>
                                        <Form.Label className="ml5percent mt-2">PEZA/Free Port Certificate (Optional)</Form.Label>
                                    </Col>
                                    <Col sm={5}>
                                        <Form.Control
                                          style={{width: "280px"}}   
                                          className="asd" 
                                          type="file" 
                                          size="sm" 
                                          onChange={PEZAchange}
                                        />
                                    </Col>
                                </Row>
                                {/* <div className=" mb-1 margincheck form-check mt-5">
                                    
                                    <input
                                      className=" form-check"
                                      type="checkbox"
                                      //id="flexCheckDefault"
                                      onChange={handleCheckBox}
                                      //value={isChecked}
                                      name="isChecked"
                                      isValid
                                    />
                                    <h1
                                      className=" checktxt form-check-label uploadDocs"
                                      htmlFor="flexCheckDefault"
                                     
                                    >
                                      By clicking �SUBMIT� you confirm that the details and documents
                                        stated and uploaded are correct  and true. You also agree to 
                                        JobSpace�s Privacy  Policy, on collection of personal data ensures
                                        veracity of corporate documents prior to use of JobSpace
                                        job posting features{" "}
                                    </h1>
                                    <text
                                      className=" checktxt form-check-label"
                                      htmlFor="flexCheckDefault"
                                     
                                    >
                                        
                                    </text>
                                </div> */}
                                <Row className="mt-5">
                                    <Col sm={1}></Col>
                                    <Col sm={1}>
                                        
                                        <input
                                            className="mt-2 ml-4 form-check"
                                            type="checkbox"
                                            //id="flexCheckDefault"
                                            onChange={handleCheckBox}
                                            //value={isChecked}
                                            name="isChecked"
                                            //isValid
                                        />
                                    </Col>
                                    <Col sm={9}>
                                        <h1
                                        className=" checktxt form-check-label uploadDocs"
                                        htmlFor="flexCheckDefault"
                                        
                                        >
                                        By clicking SUBMIT you confirm that the details and documents
                                            stated and uploaded are correct  and true. You also agree to 
                                            JobSpace Privacy  Policy, on collection of personal data ensures
                                            veracity of corporate documents prior to use of JobSpace
                                            job posting features{" "}
                                        </h1>
                                    </Col>
                                    <Col sm={1}></Col>
                                </Row>
                                <div className="center">
                                    {/* <Button
                                        type="submit"
                                        className="btn btn-hover mr-auto mb-5 mt-5"
                                        color="success"
                                        size="sm"
                                        onClick={handleSubmitFILES}
                                        >
                                            SUBMIT
                                    </Button> */}
                                    
                                    {!isshow && <Button type="submit"
                                        className="btn btn-hover mr-auto mb-5 mt-5"
                                        color="success"
                                        size="sm"
                                        disabled={dissableBtn}
                                       
                                         /* onClick={onFormSubmit} */>Submit</Button>}
                                </div>
                                {/* <Button  onClick={copyToClipboard} className="" size="sm" variant="dark">BACK</Button> */}
                               
                           </Form>
                        </div>
                    </Col>

                        
                      
                    </Row>
                    {/* <Alert className="alerthieght" show={isshow} variant="success">
                        <h5 className="successsubmited"> Succesfully submitted</h5>
                        
                            <Button className="btn btn-hover mr-auto mb-5 mt-5"
                            color="danger"
                            size="sm"  onClick={() => setShow(false)} variant="outline-success">
                                Close 
                            </Button>
                        
                    </Alert> */}
                  </Container>
                
                  <ScrolltoTop />
          </div>
        </React.Fragment>
      );

}
/* render(<CompanyDocuments />, document.querySelector("#root"));*/
document.querySelector("#root")
export default CompanyDocuments; 